'use client'

import React from 'react'

import InfiniteScrollProductListDS from '@src/components/blocks/infinite-scroll-product-list-ds'
import type { InfiniteScrollProductListProps } from '@src/components/blocks/infinite-scroll-product-list-ds'
import { shouldUseDesignSystem } from '@src/utils/should-use-design-system'

import InfiniteScrollProductListLegacy from './infinite-scroll-product-list-legacy'

export default function InfiniteScrollProductList(props: InfiniteScrollProductListProps) {
  if (shouldUseDesignSystem()) {
    return <InfiniteScrollProductListDS {...props} />
  }
  return <InfiniteScrollProductListLegacy {...props} />
}
